import { ScreenContainerRef } from '../../../../context'
import { FilterDivider } from '../../../FilterDivider'
import { PageActions } from '../../../Page'
import { Pagination } from '../../../Pagination'
import { getMockViewingsDefaultColumns } from '../../../RentalPortalViewing'
import { SelectionToolbar } from '../../../SelectionToolbar'
import { Skeleton } from '../../../Skeleton'
import {
  getSelectedSize,
  getTableResetSortingButton,
  Table,
  TableConfigModal,
  TableControlBar,
  TableControlButtons,
  TableMassAction,
} from '../../../Table'
import { RentalPortalViewRegimeControl } from '../../RentalPortalViewRegimeControl'
import { RentalPortalViewingCalendar } from '../RentalPortalViewingCalendar'
import {
  QA_NAME_VIEWINGS_TABLE,
  VIEWINGS_TABLE_SKELETON_ROWS,
} from '../RentalPortalViewings.constants'
import { RentalPortalViewingTableRow } from '../RentalPortalViewingTableRow'

import * as styles from './RentalPortalViewingTableLayout.module.css'

function RentalPortalViewingTableLayout({
  activeItem,
  calendar,
  changeViewTypeButtonProps,
  emptyState = null,
  errorState = null,
  getViewingItemActions,
  hasBodyError,
  hasTable,
  isCalendarRegime,
  massActions,
  modal = null,
  setMassAction,
  tablePage,
  onCallItemAction,
  onChangeFocusedRow,
  onClickApplicant,
  onClickCalendarViewing,
  onClickEmptyCalendarCell,
  onClickRow,
  onMouseDownRow,
}) {
  const {
    checkIsItemSelected,
    columns,
    entity,
    exclude,
    handleApply,
    handleConfigOpen,
    handleExclude,
    handleRefresh,
    handleResetOrdering,
    handleSelect,
    handleSelectAll,
    handleSelectAllPages,
    handleSetColumns,
    handleSetOrdering,
    handleSetPagination,
    handleSetSize,
    handleUnselectAllPages,
    isAllSelected,
    isConfigOpen,
    isLoading,
    isRefetching,
    isRemoveSelection,
    items,
    ordering,
    pageScrollWrapperRef,
    pagination,
    requiredColumns,
    selectAllPages,
    selected,
    setConfigOpen,
  } = tablePage

  return (
    <>
      {hasTable ? (
        <>
          <TableControlBar>
            {isCalendarRegime ? null : (
              <TableMassAction
                responsive
                actions={massActions}
                isAllSelected={isAllSelected}
                isLoading={isLoading}
                isRemoveSelection={isRemoveSelection}
                selectedSize={getSelectedSize({
                  exclude,
                  pagination,
                  selectAllPages,
                  selected,
                })}
                setMassAction={setMassAction}
                onSelectAll={handleSelectAll}
              />
            )}
            <PageActions className={styles.pageActions}>
              <TableControlButtons
                keepChangeViewTypeButtonOnNarrowScreen
                ChangeViewTypeButton={RentalPortalViewRegimeControl}
                DensityButton={null}
                ResetSortingButton={
                  isCalendarRegime ? null : getTableResetSortingButton(ordering)
                }
                changeViewTypeButtonProps={changeViewTypeButtonProps}
                className={styles.controlButtons}
                configButtonProps={{
                  disabled: isCalendarRegime,
                  onClick: handleConfigOpen,
                }}
                isSkeleton={isLoading}
                refreshButtonProps={{
                  isLoading: isRefetching,
                  onClick: handleRefresh,
                }}
                resetSortingProps={{ onClick: handleResetOrdering }}
              />
              {isCalendarRegime ? null : (
                <>
                  <FilterDivider />
                  {isLoading ? (
                    <Skeleton className={styles.paginationSkeleton} />
                  ) : (
                    <Pagination
                      responsive
                      value={pagination}
                      onChange={handleSetPagination}
                      onChangeSize={handleSetSize}
                    />
                  )}
                </>
              )}
            </PageActions>
          </TableControlBar>
          {isCalendarRegime ? (
            <RentalPortalViewingCalendar
              calendar={calendar}
              onClickApplicant={onClickApplicant}
              onClickEmptyCell={onClickEmptyCalendarCell}
              onClickViewing={onClickCalendarViewing}
            />
          ) : hasBodyError ? (
            errorState
          ) : !(items?.items?.length > 0) && !isLoading ? (
            emptyState
          ) : (
            <Table
              TableRow={RentalPortalViewingTableRow}
              checkIsItemSelected={checkIsItemSelected}
              columns={columns}
              containerRef={pageScrollWrapperRef}
              context={QA_NAME_VIEWINGS_TABLE}
              headerRowProps={{
                ordering,
                onApply: handleApply,
                onSetColumns: handleSetColumns,
                onSetOrdering: handleSetOrdering,
              }}
              isLoading={isLoading}
              items={items?.items}
              rowProps={{
                activeItem,
                exclude,
                getActions: getViewingItemActions,
                isSelectedAll: selectAllPages,
                selected,
                onCallAction: onCallItemAction,
                onClick: onClickRow,
                onClickApplicant,
                onMouseDown: onMouseDownRow,
                onSelect: selectAllPages ? handleExclude : handleSelect,
              }}
              skeletonProps={{
                headerRowClassName: styles.skeletonHeaderRow,
                rowClassName: styles.skeletonRow,
              }}
              skeletonRows={VIEWINGS_TABLE_SKELETON_ROWS}
              onChangeFocusedRow={onChangeFocusedRow}
            />
          )}
        </>
      ) : (
        emptyState
      )}
      {selected.length > 0 || selectAllPages ? (
        <SelectionToolbar
          allSelected={selectAllPages || selected.length === pagination.count}
          count={pagination.count}
          excludeCount={exclude.length}
          selected={selected.length}
          onClose={handleUnselectAllPages}
          onSelectAll={handleSelectAllPages}
        />
      ) : null}
      {isConfigOpen ? (
        <TableConfigModal
          columns={columns}
          entity={entity}
          getDefaultColumns={getMockViewingsDefaultColumns}
          requiredColumns={requiredColumns}
          setColumns={handleSetColumns}
          setConfigOpen={setConfigOpen}
          onApply={handleApply}
        />
      ) : null}
      <ScreenContainerRef value={null}>{modal}</ScreenContainerRef>
    </>
  )
}

export default RentalPortalViewingTableLayout
